module.exports = __webpack_public_path__ + "static/ss3.131b5507.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/tst/ss3.png
// module id = 1210
// module chunks = 39732927749384